



















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getGroupRoles, setGroupRoles } from '@/api/systemDepartmentRole';
import selectMember from '@/components/project/selectMember.vue';
import { searchByName } from '@/api/common';

interface Role {
  roleId: Number;
  position: String;
  memberKey: String;
  members: Person[];
}
interface Relation {
  leader: Person;
  members: Person[];
  remark: String;
}

interface Person {
  id: Number;
  nickname: String;
}

@Component({
  components: { selectMember }
})
class DepartmentRole extends Vue {
  totalList: Role[] = [];
  growthList: Role[] = [];
  earlyList: Role[] = [];
  functionList: Role[] = [];
  peopleList = [];
  IMList: Person[] = [];
  // columns = [
  //   { title: 'IL', dataIndex: 'leader.nickname', align: 'center', width: '100px' },
  //   { title: '绑定IM', align: 'left', width: '500px', scopedSlots: { customRender: 'members' } },
  //   { title: '备注', align: 'left', width: '300px', scopedSlots: { customRender: 'remark' } }
  // ];
  // relationList: Relation[] = [];

  async created() {
    this.fetchPeopleList();
    await this.initGroupList();
    // await this.initRelationList();
  }

  async fetchPeopleList() {
    try {
      let res = await searchByName('');
      this.peopleList = res.data.list || [];
    } catch (e) {
      this.peopleList = [];
    }
  }

  async initGroupList() {
    let res = await getGroupRoles();
    if (res.code === 200) {
      let { data = [] } = res;
      data.forEach(_ => {
        _.memberKey = `${_.group}-${_.position}`;
      });
      this.totalList = data;
      this.growthList = data.filter(_ => _.group === 0);
      this.earlyList = data.filter(_ => _.group === 1);
      this.functionList = data.filter(_ => _.group === 2);
    }
  }

  // async initRelationList() {
  //   let res = await getBindRelations();
  //   if (res.code === 200) {
  //     let { data = [] } = res;
  //     this.relationList = data;
  //     this.setRelationLeaders();
  //     this.setRelationMembers();
  //   }
  // }

  delUserIds(user, index) {
    const item: any = this.totalList.find(_ => _.memberKey === index);
    item.members = item.members.filter(_user => _user.id !== user.id);
    // this.memberChange(index);
  }

  // choseUserIds(data, index) {
  //   this.memberChange(index);
  // }

  // memberChange(index) {
  //   let type = index.split('-')[1];
  //   if (type === 'IL') {
  //     this.setRelationLeaders();
  //   } else if (type === 'IM') {
  //     this.setRelationMembers();
  //   }
  // }

  // setRelationMembers() {
  //   let IMList = this.getILOrIM('IM');
  //   this.IMList = IMList;
  //   let IMMAP = IMList.reduce((map, _) => {
  //     map[_.id] = true;
  //     return map;
  //   }, {});
  //   this.relationList.forEach(_ => {
  //     _.members = _.members.filter(member => IMMAP[`${member.id}`]);
  //   });
  // }

  // setRelationLeaders() {
  //   let ILList = this.getILOrIM('IL');
  //   let { relationList } = this;
  //   let realtionMap = relationList.reduce((map, relation) => {
  //     map[`${relation.leader.id}`] = relation;
  //     return map;
  //   }, {});
  //   this.relationList = ILList.map(_ => {
  //     let relation = realtionMap[_.id];
  //     if (relation) {
  //       return relation;
  //     } else {
  //       return {
  //         leader: _,
  //         members: [],
  //         remark: ''
  //       };
  //     }
  //   });
  // }

  getILOrIM(type) {
    let list = this.totalList
      .filter(_ => _.position === type)
      .reduce((list, role) => {
        role.members.forEach(member => {
          if (!list.some(item => item.id === member.id)) {
            //需要去重
            list.push(member);
          }
        });
        return list;
      }, [] as any[]);
    return list;
  }

  async save() {
    await this.saveRoles();
    // await this.saveRelation();
    this.$message.success('保存成功');
  }

  async saveRoles() {
    let { totalList } = this;
    let body = totalList.reduce((map, role) => {
      map[`${role.roleId}`] = role.members.map(_ => _.id);
      return map;
    }, {});
    let res = await setGroupRoles(body);
    if (res.code !== 200) {
      throw new Error();
    }
  }

  // async saveRelation() {
  //   let { relationList } = this;
  //   let body = relationList.map(_ => ({
  //     leaderId: _.leader.id,
  //     memberIds: _.members.map(_ => _.id),
  //     remark: _.remark
  //   }));
  //   let res = await bindLeaderMember(body);
  //   if (res.code !== 200) {
  //     throw new Error();
  //   }
  // }

  back() {
    this.$router.go(-1);
  }
}

export default DepartmentRole;
